import { LASFile } from '../../db/LASFile';
import type { MediaUnion } from '../../db/MediaUnion';

export const getFileSize = (media: MediaUnion) => {
  if (media instanceof LASFile) return lasFileSize(media);
  return null;
};

function lasFileSize(media: LASFile) {
  let sizeUnit = 'Byte';
  let sizeInByte = media.meta?.size ?? 0;

  if (sizeInByte > 1000) {
    sizeInByte = sizeInByte / 1000;
    sizeUnit = 'KB';
  }
  if (sizeInByte > 1000) {
    sizeInByte = sizeInByte / 1000;
    sizeUnit = 'MB';
  }
  return `${sizeInByte.toFixed(2)} ${sizeUnit}`;
}
